import { isPlatformBrowser } from '@angular/common';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { JSEncrypt } from 'jsencrypt';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { ApiConstants } from '../constants/api.constants';
import { GlobalConstants } from '../constants/globals';
import { environment } from './../../../environments/environment';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
    isBrowser;
    constructor(
        private cookies: CookieService,
        @Inject(PLATFORM_ID) private platformId: any
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const url = request.url;

        if (this.isBrowser) {
            // const JsEncryptModule = require('jsencrypt');
            const encrypt = new JSEncrypt({ default_key_size: '2048' });
            encrypt.setPublicKey(environment.ENCRYPTION_PUBLIC_KEY);
            if (!url.includes(GlobalConstants.ATTACHMENTS_HOST) && !url.includes('logins')) {
                const requestHeaders = {
                    'Content-Type': 'application/json',
                    'API-CLIENT': encrypt
                        .encrypt(environment.API_CLIENT + ';' + new Date().toUTCString())
                        .toString()
                        .trim(),
                    // TODO:TEMP:
                    Authorization: 'Bearer ' + this.cookies.get('token'),
                    //Authorization: this.cookies.getAll()['email'] ? this.cookies.getAll()['email'] : '',
                    'Accept-Language': this.cookies.get('lang'),
                    'API-DATE': new Date().toUTCString(),
                    Agent: 'web'
                };

                // to handle multipart/form-data for attachments for reports
                let matchReportUpload;
                if (url.includes('/reports/')) {
                    const urlReport = url;
                    const regex = /\/reports\/(\d+)/;
                    matchReportUpload = urlReport.match(regex);
                    if (matchReportUpload != undefined && matchReportUpload != null) {
                        if (url.includes('/v1/private/reports/' + matchReportUpload[1] + '/attachments')) {
                            delete requestHeaders['Content-Type'];
                        }
                    }
                }

                // to handle multipart/form-data for attachments
                if (
                    url.includes(ApiConstants.REQUESTER_UPLOAD_URL) ||
                    url.includes('/attachments/upload') ||
                    url.includes(ApiConstants.CREATE_NEW_FOLDER) ||
                    url.includes(ApiConstants.TICKETING_UPLOAD_URL) ||
                    url.includes(ApiConstants.CALL_RECORD_UPLOAD_URL)
                ) {
                    delete requestHeaders['Content-Type'];
                }
                request = request.clone({
                    withCredentials: true,
                    setHeaders: requestHeaders
                });
            }
        }
        return next.handle(request);
    }
}
